import React from "react";
import styled from "styled-components";
import Sprig from "./Sprig";
import logo from "../assets/mainLogo.png";
import { useLang } from "../i18n/LanguageContext";

export default function Hero() {
  const { t } = useLang();

  const scrollToExplore = () => {
    const el = document.getElementById("explore");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Wrap>
      <Rise $d={1}>
        <img src={logo} />
      </Rise>
      <Title $d={2}>
        {t("hero.title")}
        <br />
        <em>{t("hero.titleEm")}</em>
      </Title>
      <Sub $d={3}>{t("hero.subtitle")}</Sub>
      <Cta $d={4} onClick={scrollToExplore}>
        {t("hero.cta")}
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M12 5v14M19 12l-7 7-7-7" />
        </svg>
      </Cta>
    </Wrap>
  );
}

const Wrap = styled.header`
  text-align: center;
  max-width: 1300px;
  margin: 0 auto;
  padding: clamp(60px, 11vw, 120px) clamp(20px, 5vw, 64px)
    clamp(40px, 7vw, 70px);
`;

const rise = `
  opacity: 0;
  transform: translateY(22px);
  animation: amoraRise 0.9s cubic-bezier(.2,.7,.2,1) forwards;
  @keyframes amoraRise { to { opacity: 1; transform: translateY(0); } }
`;

const Rise = styled.div`
  ${rise}
  animation-delay: ${({ $d }) => $d * 0.13}s;
  img {
    width: 30px;
  }
`;

const Title = styled.h1`
  ${rise}
  animation-delay: ${({ $d }) => $d * 0.13}s;
  font-family: ${({ theme }) => theme.font.display};
  font-weight: 500;
  font-size: clamp(38px, 6.4vw, 72px);
  line-height: 1.04;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.ink};
  em {
    font-style: italic;
    color: ${({ theme }) => theme.colors.green};
  }
`;

const Sub = styled.p`
  ${rise}
  animation-delay: ${({ $d }) => $d * 0.13}s;
  margin: 24px auto 0;
  max-width: 560px;
  font-size: clamp(16px, 2.2vw, 19px);
  color: ${({ theme }) => theme.colors.inkSoft};
`;

const Cta = styled.button`
  ${rise}
  animation-delay: ${({ $d }) => $d * 0.13}s;
  margin-top: 36px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: ${({ theme }) => theme.colors.green};
  color: ${({ theme }) => theme.colors.cream};
  font-weight: 500;
  font-size: 15px;
  padding: 15px 30px;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  transition: 0.25s;
  &:hover {
    background: ${({ theme }) => theme.colors.greenDeep};
    transform: translateY(-2px);
  }
`;
